import styled from 'styled-components'

export const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  padding: 3rem 0;
  margin: 0 auto;
  max-width: 960px;
  width: 100%;
`
